<section class="bredcrumb">
  <div class="wrapper">
    <div class="breadcrumb-content">
      <i class="icon icon-logo-notext"></i>
      <span class="red">&nbsp;<a [routerLink]="['/'] | localize">Visit Hungary</a></span>
    </div>
  </div>
</section>
